import React from 'react';
import { motion } from 'framer-motion';

export default function RefundPolicy() {
  return (
    <div className="bg-gray-50 min-h-screen py-16 px-4 sm:px-6 lg:px-8">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8 sm:p-12 text-gray-800"
      >
        <h1 className="text-4xl font-extrabold text-gray-900 mb-8 font-display">Refund & Return Policy</h1>
        
        <div className="space-y-6 text-sm sm:text-base leading-relaxed">
          <p className="text-gray-500 italic">Last updated: {new Date().toLocaleDateString()}</p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. 30-Day Return Policy</h2>
          <p>
            We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.
            To be eligible for a return, your item must be in the same condition that you received it, unworn or unused, with tags, and in its original packaging. You'll also need the receipt or proof of purchase.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Initiation of Return</h2>
          <p>
            To start a return, you can contact us at info@genericideas.com. If your return is accepted, we'll send you a return shipping label, as well as instructions on how and where to send your package. Items sent back to us without first requesting a return will not be accepted.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Damages and Issues</h2>
          <p>
            Please inspect your order upon reception and contact us immediately if the item is defective, damaged or if you receive the wrong item, so that we can evaluate the issue and make it right.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Non-Returnable Items</h2>
          <p>
            Certain types of items cannot be returned, like perishable goods, custom products (such as special orders or personalized items), and personal care goods. Please get in touch if you have questions or concerns about your specific item.
            Unfortunately, we cannot accept returns on sale items or gift cards.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Refunds</h2>
          <p>
            We will notify you once we've received and inspected your return, and let you know if the refund was approved or not. If approved, you'll be automatically refunded on your original payment method (e.g., via Stripe) within 5-10 business days. Please remember it can take some time for your bank or credit card company to process and post the refund too.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">6. Contact Info</h2>
          <p>
            For any return queries, please email us at sales@genericideas.com.
          </p>
        </div>
      </motion.div>
    </div>
  );
}
